import React, { useContext } from "react";
import { PurchaseValidationContext } from "./PurchaseValidationContext";
import pluralize from "pluralize";
import { humanizeText } from "../utils/StringFormatters";
import { displayCurrency, formatPharmacyGroupName } from "../utils/Helpers";
import { useSearchParams } from "../Hooks/useSearchParams";
import MixpanelService from "../utils/MixpanelService";

export const AccountsTableRow = ({ account, title }) => {
  const { setAccountModal, manufacturers, coveredEntity340bId } =
    useContext(PurchaseValidationContext);

  const [searchParams, setSearchParams] = useSearchParams();

  const manufacturerLabel = manufacturers.find((m) => m.value === account.manufacturer)?.label;

  return (
    <>
      <tr className="sm t--sm">
        <td>
          <div className="t--500">{manufacturerLabel}</div>
          <div className="t--secondary">{humanizeText(account.network)}</div>
        </td>
        <td>
          <div>
            <div className="t--sm t--500 mb-1">{formatPharmacyGroupName(account.group_name)}</div>
            {account.account_type !== "cp" ? (
              <div className="t--sm t--subtitle">
                {account.account_type === "unassigned"
                  ? "Unknown Pharmacy"
                  : `${account.pharmacy_count} ${pluralize("Pharmacy", account.pharmacy_count)} Assigned`}
              </div>
            ) : null}
          </div>
        </td>
        <td>{account.outstanding_purchase_count}</td>
        <td>{displayCurrency(account.outstanding_purchase_wac_value)}</td>
        <td>
          <div className="flex justify-content-end align-items-end">
            <button
              className="button button--white button--md"
              onClick={() => {
                MixpanelService.track("esp_horizon_view_details_accessed", {
                  account_group: title,
                  mfr_details: manufacturerLabel,
                });
                setAccountModal({ accountId: account.id });
                // append id_340b just in case its not there already and they link out to account
                setSearchParams({
                  ...searchParams,
                  account_id: account.id,
                  id_340b: coveredEntity340bId,
                });
              }}
            >
              View Details
            </button>
          </div>
        </td>
      </tr>
    </>
  );
};
